import { $$, doc } from './util.js';

/* 10. DOCS SCREENSHOT FALLBACK

   Safety net for the screenshot rewriting done in
   templates/documentation/includes/hub-article.html. Every docs screenshot
   was originally hotlinked to lh3-lh6.googleusercontent.com; the ones that
   still resolved are mirrored under /assets/hub/docs-media/ and served from
   there, with the original URL kept in data-remote-src.

   Two things can still fail, and both are handled here rather than with an
   inline onerror= — the CSP sets script-src without 'unsafe-inline', which
   blocks inline event-handler attributes:

     1. A docs page is re-authored with a fresh hotlink that has not been
        mirrored yet, so the local file 404s. Retry data-remote-src once, so
        a stale mirror degrades to the old behaviour instead of breaking.
     2. The hotlink is one of the ~10 that Google has already dropped, so
        the retry 404s too. Swap in the same placeholder the template emits
        for the permanently-lost screenshots, so the reader gets a caption
        instead of a broken-image icon.

   'error' does not bubble, hence the capture-phase listener on the document,
   registered at parse time so it is in place before the images load. */
function handleImageFailure(img) {
	var remote = img.getAttribute('data-remote-src');
	if (remote && !img.getAttribute('data-tried-remote')) {
		img.setAttribute('data-tried-remote', '1');
		img.src = remote;
		return;
	}

	var span = doc.createElement('span');
	span.className = 'img-missing';
	span.setAttribute('role', 'img');
	span.setAttribute('aria-label', 'Screenshot unavailable');
	span.textContent = 'Screenshot unavailable';
	if (img.parentNode) { img.parentNode.replaceChild(span, img); }
}

// Registered at module-evaluation time (import order in index.js) — the same
// parse-time timing the former IIFE gave it, before the article images load.
doc.addEventListener('error', function (e) {
	var img = e.target;
	if (!img || img.tagName !== 'IMG') { return; }
	/* Only ever touch authored article images. Right now the chrome is all
	   inline SVG so nothing else on the page is an <img>, but this must not
	   start captioning a logo if that changes. */
	if (!img.closest || !img.closest('.article-body')) { return; }
	handleImageFailure(img);
}, true);

/* hub.js is loaded at the end of <body>, so an image early in the article
   can fail before the listener above exists. Once the DOM is ready, sweep
   for images that already finished loading with no intrinsic size — the
   standard way to spot an <img> whose request failed before you were
   listening. */
export function initDocsImageFallback() {
	$$('.article-body img').forEach(function (img) {
		if (img.complete && img.naturalWidth === 0) { handleImageFailure(img); }
	});
}
